// @flow

import React from 'react';
import PropTypes from 'prop-types';
import MDEditor from '@uiw/react-md-editor';
import {makeStyles} from '@material-ui/styles';

import {colors} from '../../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  editorText: {
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '200px',
    maxHeight: '100%!important',
    position: 'static',
    boxShadow: 'none!important',
    '& .w-md-editor-toolbar': {
      width: 'fit-content',
      position: 'static',
      top: 'unset',
      left: 'unset',
      zIndex: '0',
      height: '35px!important',
      borderBottom: 'none',
      backgroundColor: 'unset',
      '& li': {
        border: '1px solid #E8E8ED!important',
        borderRadius: '2px!important',
      },
      '& li:nth-of-type(10)': {
        display: 'none!important',
      },
      '& li:nth-of-type(11)': {
        display: 'none!important',
      },
      '& li:nth-of-type(12)': {
        display: 'none!important',
      },
      '& ul li button': {
        backgroundColor: '#FFFFFF',
      },
      '& ul:last-of-type': {
        display: 'none!important',
      },
    },

    '& .w-md-editor-content': {
      height: '100%!important',
      maxHeight: '100%!important',
      padding: theme.spacing(1),
      '& > div': {
        backgroundColor: '#FFFFFF',
      },
      '& .w-md-editor-input': {
        border: '1px solid #E8E8ED!important',
      },
    },
    '& .w-md-editor-text-input': {
      fontFamily: '"Poppins", "Muli", sans-serif !important',
      color: colors.grey900,
      fontSize: 14,
      fontWeight: 500,
    },
    '& .w-md-editor-text-pre > code': {
      fontFamily: '"Poppins", "Muli", sans-serif !important',
      color: colors.grey900,
      fontSize: 14,
      fontWeight: 500,
    },
    '& .w-md-editor-content > div > div > div > pre > code': {
      fontFamily: '"Poppins", "Muli", sans-serif !important',
    },
    '& .w-md-editor-content > div > div > div > pre > code > span .italic': {
      fontStyle: 'unset',
    },
  },
  sticky: {
    '& .w-md-editor-toolbar': {
      width: 'fit-content',
      backgroundColor: colors.grey200,
      padding: theme.spacing(2, 1),
    },
  },
}));

type Props = {
  handleDescription: (value: string) => void,
  text: string,
  placeholder?: string,
  disabled?: boolean,
  autoFocus?: boolean,
  className?: string,
  previewMode?: 'live' | 'preview' | 'edit',
};

function CustomEditor(props: Props) {
  const {
    handleDescription,
    text,
    placeholder,
    disabled = false,
    autoFocus,
    className,
    previewMode = 'edit',
  } = props;

  const classes = useStyles();

  return (
    <div data-color-mode="light" className={className}>
      <MDEditor
        textareaProps={{
          disabled: disabled,
          placeholder: placeholder ? placeholder : 'Texto descriptivo',
        }}
        preview={previewMode}
        visibleDragbar={false}
        className={classes.editorText}
        value={text}
        disabled={disabled}
        onChange={handleDescription}
        autoFocus={autoFocus}
      />
    </div>
  );
}

export default React.memo<Props>(CustomEditor);

CustomEditor.propTypes = {
  handleDescription: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
